import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import appStyles from './css/App.module.css';
import './css/Reset.css';

import TechNavigator from './Components/TechNavigator';

const App = () => {
  const location = useLocation();

  useEffect(() => {
    const loadAnalyticsEvent = async () => {
      const { logAnalyticsEvent } = await import('./utils/analyticsUtils');

      logAnalyticsEvent('page_view', {
        page_title: document.title,
        page_location: window.location.href,
        page_path: location.pathname
      });
    }

    loadAnalyticsEvent();
  }, [location]);

  return (
    <div className={appStyles.backgroundContainer}>
      <TechNavigator />
    </div>
  )
}

export default App;